import { Typography, Box } from "@mui/material";

const Footer = () => {
  return (
    <Box
      sx={{
        textAlign: "center",
        p: 1,
        pt: 0,
        bgcolor: "transparent",
        color: "black",
        width: "100%",
      }}
    >
      <Typography variant="body2">
        &copy; {new Date().getFullYear()} Colombo Logistics World (Pvt) Ltd. All Rights Reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
